export default __webpack_public_path__ + "static/media/no-rewards.579f59be.svg";